export const environment = {
    production: true,
    hmr: false,
    environment: 'production',
    pathConfig: 'assets/config.prod.json',
    rollbar: {
        accessToken: 'd83fcdee10944540bf2cfb43778b94a3'
    }
};
